import { render, staticRenderFns } from "./epb-virtual-scroller-list.component.vue?vue&type=template&id=ca6d4fa8&scoped=true"
import script from "./epb-virtual-scroller-list.component.vue?vue&type=script&lang=ts"
export * from "./epb-virtual-scroller-list.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-virtual-scroller-list.component.vue?vue&type=style&index=0&id=ca6d4fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d4fa8",
  null
  
)

export default component.exports